module.exports = __webpack_public_path__ + "static/img/logo.0b4457f5.png";